<div class="form-group">
  <label class="fw-bold py-2">{{ label }}</label>
  <div class="checkbox-container" [class.is-invalid]="hasError">
    @for (option of options; track option) {
      <div class="checkbox-item">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            [id]="option.key"
            [value]="option.key"
            [checked]="isChecked(option.key)"
            [disabled]="readonly"
            (change)="onCheckboxChange($event, option.key)">
          <label class="form-check-label" [for]="option.key">{{ option.value }}</label>
        </div>
      </div>
    }
  </div>
</div>